module.exports = __webpack_public_path__ + "img/ExcellenceInEducationSealOfRecognition.7e0dd824.jpg";